/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceCategoryRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceCategoryRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceCategoryRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceCategoryRegexQueryOperator>): ResourceCategoryRegexQueryOperator {
        let obj = Object.assign(new ResourceCategoryRegexQueryOperator(), model);
        ResourceCategoryRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceCategoryRegexQueryOperator>): ResourceCategoryRegexQueryOperator {
        if (!model) return null;
        return ResourceCategoryRegexQueryOperator.newInstance(<ResourceCategoryRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceCategoryRegexQueryOperator) {
        if (!obj) return;

        models.ResourceCategoryRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceCategoryRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceCategoryRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_category) {
            models.Regex.fixupPrototype(this.resource_category);
        }
    }

    /**
     * Include response that has the given resource_category
     */
    resource_category: models.Regex;

}
